/* globals Store */
import api from "@/utils/backend-api";
import { mapState } from "vuex";
import {Order} from "@/models";
import {
  sendSuccessNotice,
  sendErrorNotice,
  closeNotice,
  getDefaultPagination,
  commitPagination,
} from "@/utils/store-util.js";

import { get } from "lodash";

const state = {
  items: [],
  qsitems: [],
  resume: { RUB: {
    sell: {
      fiat: 0,
      usdt: 0,
      rate: 0,
      count: 0
    },
    buy: {
      fiat: 0,
      usdt: 0,
      rate: 0,
      count: 0
    },
  }
  },

  currencies: ['RUB'],
  pagination: {},
  mode: '',
  loading: false,
  snackbar: true,
  notice: "",
  order: new Order(),
};

const getters = {
};

const actions = {
  searchOrders ({ commit }, searchQuery, pagination) {
    api.getData("orders?" + searchQuery).then(res => {
      const orders = res.data;
      commit("setItems", orders)
//      commitPagination(commit, orders);
//      commit("setLoading", false)
    });
  },
  quickSearch ({ commit }, { headers, qsFilter, qsitems, side, pagination }) {
    let orders = qsitems.filter(r => headers.some(header => {
          const val = get(r, [header.value]);
          return (val && val
              .toString()
              .toLowerCase()
              .includes(qsFilter)) || false;
    }));
    orders = orders.filter(r => {
          const sideval = get(r, 'side');
          if (sideval === 0 && side === 'buy') return false;
          if (sideval === 1 && side === 'sell') return false;
          return true;
    });
    commit("setItems", orders)
    commitPagination(commit, orders);
  },
  setLoading ({ commit }, loading) {
     commit("setLoading", loading)
  },

  closeSnackBar ({ commit }, timeout ) {
     closeNotice(commit, timeout);
  }
};

const mutations = {
  setItems (state, orders) {
    state.items = orders;

    let total = {};
    let currencies = [];
    for (const [key, order] of Object.entries(orders)) {
      if (Number(order.status) === 50) {
        if (typeof (total[order.currencyId]) === 'undefined') {
          currencies.push(order.currencyId);
          total[order.currencyId] = {sell: {usdt: 0, fiat: 0, count: 0}, buy: {usdt: 0, fiat: 0, count: 0}};
        }
        total[order.currencyId][order.side === 0 ? 'buy' : 'sell']['fiat'] += Number(order.amount);
        total[order.currencyId][order.side === 0 ? 'buy' : 'sell']['usdt'] += Number(order.notifyTokenQuantity);
        total[order.currencyId][order.side === 0 ? 'buy' : 'sell']['count'] += 1;
      }
    }
    for (let [key, value] of Object.entries(total)) {
      value.currencyId = key;
      value.sell.rate = Number(value.sell.fiat) / Number(value.sell.usdt) || 0;
      value.buy.rate = Number(value.buy.fiat) / Number(value.buy.usdt) || 0;
    }
    state.resume = total;
    state.currencies = currencies;
  },
  setCurrencies (state, currencies) {
    state.currencies = currencies;
  },

//  setPagination (state, pagination) {
//    state.pagination = pagination;
//  },
//  setLoading (state, loading) {
//    state.loading = loading;
//  },
//  setNotice (state, { notice }) {
//    console.log(" notice .... ", notice);
//    state.notice = notice;
//  },
//  setSnackbar (state, { snackbar }) {
//    state.snackbar = snackbar;
//  },
//  setOrder (state, {order}) {
//    state.order = order
//  },
//  setMode (state, {mode}) {
//    state.mode = mode
//  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};

function refreshOrders (commit, orders) {
  let resume = {
    sell: {
      fiat: { sum: 0, count: 0 },
      usdt: { sum: 0, count: 0 },
      rate: 0,
    },
    buy: {
      fiat: { sum: 0, count: 0 },
      usdt: { sum: 0, count: 0 },
      rate: 0,
    },
    profit: {
      fiat: 0,
      usdt: 0,
    },
  }

  orders.forEach(item => {
    item.sum = Number(item.sum);
    item.sum_usdt = Number(item.sum_usdt);
    if (Number(item.side) === 0) {
      if (item.sum > 0 && item.sum_usdt > 0) {
        item.rate = Math.round(item.sum / item.sum_usdt * 100) / 100;
        resume.sell.rate = (resume.sell.usdt.sum * resume.sell.rate + item.sum) / (resume.sell.usdt.sum + item.sum_usdt);
      }

      if (item.sum > 0) {
        resume.sell.fiat.count++;
        resume.sell.fiat.sum += item.sum;
      }
      if (item.sum_usdt > 0) {
        resume.sell.usdt.count++;
        resume.sell.usdt.sum += item.sum_usdt;
      }

    }
    else {
      if (item.sum > 0 && item.sum_usdt > 0) {
        item.rate = Math.round(item.sum / item.sum_usdt * 100) / 100;
        resume.buy.rate = (resume.buy.usdt.sum * resume.buy.rate + item.sum) / (resume.buy.usdt.sum + item.sum_usdt);
      }

      if (Number(item.sum) > 0) {
        resume.buy.fiat.count++;
        resume.buy.fiat.sum +=  Number(item.sum);
      }
      if (Number(item.sum_usdt) > 0) {
        resume.buy.usdt.count++;
        resume.buy.usdt.sum +=  Number(item.sum_usdt);
      }
    }
  });

  const usdtProfit = resume.buy.usdt.sum - resume.sell.usdt.sum;
  const fiatProfit = resume.sell.usdt.sum * resume.sell.rate - resume.buy.usdt.sum * resume.buy.rate;

  if (window.curRate > 0) {
    resume.profit.usdt = Math.floor((fiatProfit / window.curRate + usdtProfit) * 100) / 100;
    resume.profit.fiat = Math.floor(usdtProfit * window.curRate + fiatProfit);
    resume.profit.fiatf = resume.profit.fiat.toString().split('').reverse().map((el, index) => index % 3 !== 2 ? el : ` ${el}`).reverse().join('');
  } else {
    api.getData("info/rates").then(res => {
      window.curRate = Number(res.data.usdt_rub)
      resume.profit.usdt = Math.floor((fiatProfit / window.curRate + usdtProfit) * 100) / 100;
      resume.profit.fiat = Math.round(usdtProfit * window.curRate + fiatProfit);
      resume.profit.fiatf = resume.profit.fiat.toString().split('').reverse().map((el, index) => index % 3 !== 2 ? el : ` ${el}`).reverse().join('');
      commit("setResume", resume);
    });
  }

  resume.sell.fiat.sum = Math.round(resume.sell.fiat.sum).toString().split('').reverse().map((el, index) => index % 3 !== 2 ? el : ` ${el}`).reverse().join('');
  resume.buy.fiat.sum = Math.round(resume.buy.fiat.sum).toString().split('').reverse().map((el, index) => index % 3 !== 2 ? el : ` ${el}`).reverse().join('');

  resume.buy.rate = Math.round(resume.buy.rate * 100) / 100;
  resume.sell.rate = Math.round(resume.sell.rate * 100) / 100;

  commit("setItems", orders);
  commit("setResume", resume);
}


// WEBPACK FOOTER //
// ./src/store/modules/orders.js